module.exports = __webpack_public_path__ + "img/flow1.b981ffc4.png";